import { ComputedRef } from 'vue'

import { OfficialProblemCategory } from '@/domain/entities/problem/officialProblemCategory'
import { ProblemAttachment } from '@/domain/entities/problem/problemAttachment'
import { ProblemStatistics } from '@/domain/entities/problem/problemStatistics'
import { ProblemStatisticsViewModel } from '@/presentation/viewmodels/problem/problemStatisticsViewModel'

export class ProblemStatisticsPresenter {
  private viewModel: ProblemStatisticsViewModel

  constructor(viewModel: ProblemStatisticsViewModel) {
    this.viewModel = viewModel
  }

  get problemAttachment(): ComputedRef<ProblemAttachment> {
    return this.viewModel.problemAttachment
  }

  get problemStatistics(): ComputedRef<ProblemStatistics> {
    return this.viewModel.problemStatistics
  }

  get officialProblemCategoryList(): ComputedRef<OfficialProblemCategory[]> {
    return this.viewModel.officialProblemCategoryList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async getProblemStatistics(problemId: string): Promise<void> {
    await this.viewModel.getProblemStatistics(problemId)
  }

  async getOfficialProblemCategory(): Promise<void> {
    await this.viewModel.getOfficialProblemCategory()
  }
}
